// extracted by css-extract-rspack-plugin
export default {"TextAreaElementContainer":"TextAreaElement-module__TextAreaElementContainer__mCQc_","codeViewTextArea":"TextAreaElement-module__codeViewTextArea__HWL4h"};